// Tenant theme presets — must match design_guidelines.json
export const THEME_PRESETS = {
  "warm-coral": {
    id: "warm-coral",
    name: "Urban Warmth",
    vibe: "Energetic, friendly — ideal for general home and urban services.",
    mode: "light",
    fonts: { heading: "'Plus Jakarta Sans', system-ui", body: "'DM Sans', system-ui" },
    vars: {
      "--brand-primary": "11 80% 60%",
      "--brand-primary-foreground": "0 0% 100%",
      "--brand-bg": "30 20% 99%",
      "--brand-surface": "0 0% 100%",
      "--brand-border": "20 10% 90%",
      "--brand-muted": "20 10% 96%",
      "--brand-text": "20 14% 12%",
      "--brand-text-muted": "20 8% 40%",
      "--brand-radius": "16px",
      "--brand-card-shadow": "0 4px 20px rgba(0,0,0,0.05)",
    },
    swatch: ["#EE6A4D", "#FFF8F3", "#1C1410"],
  },
  "premium-luxury": {
    id: "premium-luxury",
    name: "Midnight Premium",
    vibe: "Cinematic, expensive feel — ideal for salons, spas, premium detailing.",
    mode: "dark",
    fonts: { heading: "'Cormorant Garamond', serif", body: "'Manrope', system-ui" },
    vars: {
      "--brand-primary": "43 74% 49%",
      "--brand-primary-foreground": "0 0% 10%",
      "--brand-bg": "0 0% 7%",
      "--brand-surface": "0 0% 12%",
      "--brand-border": "0 0% 20%",
      "--brand-muted": "0 0% 15%",
      "--brand-text": "0 0% 98%",
      "--brand-text-muted": "0 0% 65%",
      "--brand-radius": "8px",
      "--brand-card-shadow": "0 8px 32px rgba(0,0,0,0.4)",
    },
    swatch: ["#D4A017", "#121212", "#FAFAFA"],
  },
  "trust-blue": {
    id: "trust-blue",
    name: "Clinical Trust",
    vibe: "Clean, sterile, reliable — for medical appointments and appliance repair.",
    mode: "light",
    fonts: { heading: "'Outfit', system-ui", body: "'Work Sans', system-ui" },
    vars: {
      "--brand-primary": "210 100% 45%",
      "--brand-primary-foreground": "0 0% 100%",
      "--brand-bg": "210 20% 98%",
      "--brand-surface": "0 0% 100%",
      "--brand-border": "210 15% 90%",
      "--brand-muted": "210 15% 95%",
      "--brand-text": "210 30% 12%",
      "--brand-text-muted": "210 10% 40%",
      "--brand-radius": "12px",
      "--brand-card-shadow": "0 2px 12px rgba(0,0,0,0.04)",
    },
    swatch: ["#0070E0", "#F4F8FC", "#0B1F36"],
  },
  "fresh-eco": {
    id: "fresh-eco",
    name: "Fresh Botanical",
    vibe: "Natural, crisp, renewing — for cleaning, pest control, eco services.",
    mode: "light",
    fonts: { heading: "'Chivo', system-ui", body: "'Figtree', system-ui" },
    vars: {
      "--brand-primary": "142 71% 35%",
      "--brand-primary-foreground": "0 0% 100%",
      "--brand-bg": "140 20% 99%",
      "--brand-surface": "0 0% 100%",
      "--brand-border": "140 15% 90%",
      "--brand-muted": "140 20% 95%",
      "--brand-text": "140 20% 12%",
      "--brand-text-muted": "140 8% 40%",
      "--brand-radius": "24px",
      "--brand-card-shadow": "0 10px 40px rgba(0,0,0,0.03)",
    },
    swatch: ["#1A8E47", "#F4FAF6", "#0E2018"],
  },
  "terracotta-earthy": {
    id: "terracotta-earthy",
    name: "Earthy Artisan",
    vibe: "Grounded, physical, warm — great for carpentry, plumbing, physical crafts.",
    mode: "light",
    fonts: { heading: "'Ysabeau', serif", body: "'Inter', system-ui" },
    vars: {
      "--brand-primary": "18 55% 52%",
      "--brand-primary-foreground": "0 0% 100%",
      "--brand-bg": "35 30% 98%",
      "--brand-surface": "35 10% 95%",
      "--brand-border": "35 20% 85%",
      "--brand-muted": "35 20% 90%",
      "--brand-text": "20 25% 18%",
      "--brand-text-muted": "20 10% 40%",
      "--brand-radius": "4px",
      "--brand-card-shadow": "none",
    },
    swatch: ["#C76B45", "#F6F0E6", "#2A1F14"],
  },
  "modern-violet": {
    id: "modern-violet",
    name: "Neon Tech",
    vibe: "Sleek, futuristic, sharp — for IT services, smart-home setups, gadgets.",
    mode: "dark",
    fonts: { heading: "'Unbounded', system-ui", body: "'Space Grotesk', system-ui" },
    vars: {
      "--brand-primary": "262 80% 65%",
      "--brand-primary-foreground": "0 0% 100%",
      "--brand-bg": "260 20% 5%",
      "--brand-surface": "260 15% 10%",
      "--brand-border": "260 20% 20%",
      "--brand-muted": "260 20% 15%",
      "--brand-text": "0 0% 98%",
      "--brand-text-muted": "260 10% 65%",
      "--brand-radius": "16px",
      "--brand-card-shadow": "0 0 20px rgba(124, 58, 237, 0.15)",
    },
    swatch: ["#7C3AED", "#0E0B1A", "#F4F3FA"],
  },
};

export const THEME_LIST = Object.values(THEME_PRESETS);

export function applyTheme(presetId = "warm-coral", overrideColor = null) {
  const preset = THEME_PRESETS[presetId] || THEME_PRESETS["warm-coral"];
  const root = document.documentElement;
  Object.entries(preset.vars).forEach(([k, v]) => root.style.setProperty(k, v));
  root.style.setProperty("--brand-heading-font", preset.fonts.heading);
  root.style.setProperty("--brand-body-font", preset.fonts.body);
  if (overrideColor) {
    root.style.setProperty("--brand-primary", overrideColor);
  }
  root.dataset.themePreset = preset.id;
  root.dataset.themeMode = preset.mode;
}

export function clearTheme() {
  const root = document.documentElement;
  ["--brand-primary","--brand-primary-foreground","--brand-bg","--brand-surface",
   "--brand-border","--brand-muted","--brand-text","--brand-text-muted",
   "--brand-radius","--brand-card-shadow","--brand-heading-font","--brand-body-font"
  ].forEach(k => root.style.removeProperty(k));
  delete root.dataset.themePreset;
  delete root.dataset.themeMode;
}
